import { Theme, styled } from '@material-ui/core';

export const NotificationsWrapper = styled('div')<Theme>(({ theme }) => ({
  marginLeft: theme.config.sidePanelScroolWidthRem,
  width: '100%',
  height: '100%',
}));
